import { render, staticRenderFns } from "./stockMovementSummaryBox.vue?vue&type=template&id=28da4c3b&"
import script from "./stockMovementSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./stockMovementSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports